import { Box } from '@mui/material';
import StepperContainer from '../components/stepper/stepperContainer';

export const EvaluateAchievableColor = () => {
  return (
    <Box className="contentPage" mt={1}>
      <h3 style={{ textAlign: 'center' }}>Evaluate Achievable Color</h3>
      <StepperContainer />
    </Box>
  );
};
